export const messages = {
  pt: {
    translations: {
      titles: {
        home: "HOME",
        skills: "Skills",
        exp: "Exp",
        projects: "Projetos",
        contact: "Contato",
      },
      main: {
        banner: "Bem vindo ao meu portfólio!",
        title: "Olá! Eu sou Gabriel Gomes",
        info: `Sou apaixonado por tecnologia desde sempre e adoro saber como tudo funciona! Embora curta especialmente a parte
        de desenvolvimento Front-end, me interesso por quase tudo relacionado ao mundo da programação. Busco estudar e praticar sempre que possível, 
        afinal, a área de tecnologia é alimentada pelo movimento constante. Não dá pra ficar parado.`,
        interests: "Tenho interesse especial em:",
      },
      skills: {
        description: "Aqui estão os meus cursos e certificações",
      },
      exp: {
        description: "Essa é a minha jornada como Dev (até aqui)",
        expTime: {
          expUticketTime: "Set 2023 - Set 2024",
          expStoneTime: "Set 2024 - Atual",
        },
      },
      projects: {
        description: "Estes são alguns dos meus projetos",
      },
      contact: {
        description: "Aguardo o seu contato!",
        fields: "Currículo",
      },
      footer: {
        title: "desenvolvido por gabrigomez",
        description: "2023 - Todos os direitos reservados",
      },
    },
  },
};
